import { apm } from '@elastic/apm-rum'
import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import singleSpaReact from 'single-spa-react'
import './i18n.payments'
import Root from './root.component'

const thisWindow: any = window
const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    const transaction = apm.startTransaction('Module Payments', 'custom')
    const url = window.location.href
    const httpSpan = transaction?.startSpan('GET ' + url)
    apm.captureError(new Error(`Error Bundary Payments ${err.stack} `))
    httpSpan?.end()
    transaction?.end()
    if (err?.stack?.includes('systemjs')) {
      history.pushState({}, '', '/error/general-error')
    }
    return <div></div>
  },
})

export const { bootstrap, mount, unmount } = lifecycles
thisWindow['@hub/payments'] = lifecycles
